module.exports = __webpack_public_path__ + "img/empty.977b6036.gif";